import { render, staticRenderFns } from "./UnityEnvironmentConfig.vue?vue&type=template&id=8f64954c&scoped=true&"
import script from "./UnityEnvironmentConfig.vue?vue&type=script&lang=js&"
export * from "./UnityEnvironmentConfig.vue?vue&type=script&lang=js&"
import style0 from "./UnityEnvironmentConfig.vue?vue&type=style&index=0&id=8f64954c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f64954c",
  null
  
)

export default component.exports